import { render, staticRenderFns } from "./BookCategory.vue?vue&type=template&id=4e3666a5&scoped=true&"
import script from "./BookCategory.vue?vue&type=script&lang=js&"
export * from "./BookCategory.vue?vue&type=script&lang=js&"
import style0 from "./BookCategory.vue?vue&type=style&index=0&id=4e3666a5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e3666a5",
  null
  
)

export default component.exports